module.exports = __webpack_public_path__ + "static/media/appsign_bg.20b9cf01.png";